import { FaceTecSessionStatus } from "facetec-sdk";

const sessionStatusMessages = {
  SessionCompleted: "The capture was completed.",
  RequestAborted: "The capture was aborted.",
  UserCancelledFaceScan: "The capture was cancelled.",
  UserCancelledIDScan: "The ID scan was cancelled.",
  LockedOut:
    "Too many failed attempts. Please wait a while before trying again.",
  CameraError: "The camera could not be started or stopped working.",
  CameraPermissionsDenied:
    "Camera access was denied. Allow camera access in your browser and try again.",
  UnknownInternalError: "An unexpected error occurred in the biometric engine.",
  IFrameNotAllowedWithoutPermission:
    "The capture cannot run in an embedded frame without camera permission.",
} as const satisfies Record<keyof typeof FaceTecSessionStatus, string>;

export default sessionStatusMessages;
